import { TableVirtualized } from "./TableVirtualized";

export default TableVirtualized;
